import { ClinicalStudies } from "../api";

export function assertStudyAcronym(value: string | undefined): ClinicalStudies {
  if (Object.values(ClinicalStudies).includes(value as ClinicalStudies)) {
    return value as ClinicalStudies;
  } else {
    throw new Error("Invalid study acronym");
  }
}
